import styled from "@emotion/styled"

export const Label = styled.div`
  font-size: ${(props) => props.theme.textSm};
  padding-bottom: 2px;
`

export const IndexText = styled.div`
  color: ${(props) => props.theme.primary};
  font-size: ${(props) => props.theme.textSm};
`